<template>
  <div class="phone-block" :style="{
    'text-align': textAlignRight ? 'right' : 'left'
  }">
    <img v-if="icon"
         alt=""
         :src="icon"
         @load="$event.target.classList.toggle('empty-img', false)"
         class="phone-icon empty-img"
    >
    <a
      v-bind:href="phone_link ?? null" target="_blank"
      class="empty-ph" :class="{'phone-link': !isBlueCross, 'working-time': isBlueCross, 'mb-2': isBlueCross }"
    >{{phone}}</a>
    <br>
    <a
      v-bind:href="time_link ?? null" target="_blank"
      class="working-time empty-ph">{{time}}</a>
  </div>
</template>

<script>
import configEnv from "@/enums/configEnv";
import ServerType from "@/enums/serverType";

export default {
  computed: {
    ServerType() {
      return ServerType
    },
    configEnv() {
      return configEnv
    }
  },
  data() {
    return {
      isBlueCross: configEnv.server_type === ServerType.BlueCross,
    }
  },
  props: {
    phone: String,
    phone_link: {
      type: [String, null],
      default: null
    },
    time: String,
    time_link: {
      type: [String, null],
      default: null
    },
    icon: {
      type: [String, null],
      default: null
    },
    textAlignRight: {
      type: Boolean,
      default: true
    }
  }
};

</script>
<style lang="scss">
.phone-block {
  display: block;
  z-index: 99;
  font-size: 16px;
  font-weight: 600;
  text-align: right;
  margin-right: 15px;
  position: relative;
}

.phone-block .phone-icon {
  width: 22px;
  height: 22px;
}

.phone-block .phone-link {
  min-width: 5rem;
}

.phone-block .working-time {
  box-sizing: border-box;
  margin-left: 10px;
  font-size: 13px;
  line-height: 1;
  color: #555;
  font-weight: 200;
  min-width: 5rem;
}

@media only screen and (max-width: 1200px) {
  .phone-block {
    margin-right: 5px;
  }
  .info-block{
    padding-left: 0;
    padding-right: 0;
  }
}
@media only screen and (max-width: 1000px) {
  .phone-block {
    margin: 0 5px 10px 0;
    width: 100%;
  }
}
@media only screen and (max-width: 767px) {
  .phone-block .phone-icon {
    width: 16px;
    height: 16px;
  }

  .phone-block {
    font-size: 12px;
  }
  .phone-block {
    margin: 0 0px 10px 0;
    width: 100%;
  }
  .phone-block .working-time{
    margin-left: 0;
  }
}

@media only screen and (max-width: 576px) {
  .phone-block .phone-icon {
    width: 12px;
    height: 12px;
  }

  .phone-block {
    font-size: 10px;
  }
  .phone-block {
    margin: 0 0px 10px 0;
    width: 100%;
  }
}

</style>
